/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CreateIdpGroupRequest {
  /**
  * The ID of the Identity Provider this group belongs to.
  */
  'idpId': string;
  /**
  * The group identifier from the Identity Provider.
  */
  'providerGroupId': string;
  /**
  * List of role IDs to assign to this IDP group.
  */
  'roleIds': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "idpId",
      "baseName": "idpId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "providerGroupId",
      "baseName": "providerGroupId",
      "type": "string",
      "format": ""
    },
    {
      "name": "roleIds",
      "baseName": "roleIds",
      "type": "Array<string>",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return CreateIdpGroupRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

